export const ApplicationConstant = {
    ApplicationID : 23,
    clientId : 14,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
